var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrcodeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "address",
    transform: "translate(-264.000000, -488.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M268.7,498.3h5.6v-5.6h-5.6V498.3z M267.8,499.3h7.5v-7.5h-7.5V499.3z M267.3,490.8h8.4 c0.3,0,0.5,0.2,0.5,0.5v8.4c0,0.3-0.2,0.5-0.5,0.5h-8.4c-0.3,0-0.5-0.2-0.5-0.5v-8.4C266.8,491,267,490.8,267.3,490.8z M264.5,488 h2.3c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-1.9v1.9c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-2.3 C264,488.2,264.2,488,264.5,488z M279,488.5v2.3c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1.9h-1.9c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5h2.3C278.8,488,279,488.2,279,488.5z M278.5,503h-2.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h1.9v-1.9 c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.3C279,502.8,278.8,503,278.5,503z M264,502.5v-2.3c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v1.9h1.9c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5h-2.3C264.2,503,264,502.8,264,502.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeicon);
export default __webpack_public_path__ + "static/media/qrcode.icon.f3869d5b.svg";
export { ForwardRef as ReactComponent };